module.exports = "/_next/static/media/Info exposed.c003b017.png";